import { GAME_CONFIG } from '../config';

export function getFloorY(z: number): number {
  const zMinus1 = GAME_CONFIG.FLOOR_Y_AT_Z_MINUS_1;
  const zZero = GAME_CONFIG.FLOOR_Y_AT_Z_ZERO;
  const zPlus1 = GAME_CONFIG.FLOOR_Y_AT_Z_PLUS_1;

  if (z <= 0) {
    return zZero + (zMinus1 - zZero) * (-z);
  }
  return zZero - (zZero - zPlus1) * z;
}

export function getScaleFromZ(z: number): number {
  return 1.0 - z * 0.5;
}

export function projectX(worldX: number, z: number): number {
  const vanishing = GAME_CONFIG.VANISHING_X;
  const factor = z * GAME_CONFIG.Z_CONVERGE_FACTOR;
  if (factor <= 0) return worldX;
  return worldX + (vanishing - worldX) * factor;
}

export function bezier(t: number, p0: number, p1: number, p2: number): number {
  const omt = 1 - t;
  return omt * omt * p0 + 2 * omt * t * p1 + t * t * p2;
}

export function clamp(v: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, v));
}
